export default __webpack_public_path__ + "media/metronic/_theme/media/error/bg6-d46cc63f82ff1fb2f345a06c308bf764.jpg";